<template>
  <component :is="currentHeader" />
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Header from "@/components/ui/header/Header.vue";
import HeaderWidget from "@/components/ui/header/HeaderWidget.vue";
import HeaderScheme from "@/components/ui/header/HeaderScheme.vue";
import HeaderSchemeEditor from "@/components/ui/header/HeaderSchemeEditor.vue";
import HeaderReservations from "@/components/ui/header/HeaderReservation.vue";
import HeaderEditBooking from "@/components/ui/header/HeaderEditBooking.vue";

const store = useStore();
const route = useRoute();

const screenType = computed(() => store.getters.screenType);
const routeName = computed(() => route.name);

const headersMap = computed(() => ({
  editBooking:
    routeName.value?.includes("booking-edit") && screenType.value === "mobile",
  reservations: routeName.value?.includes("catering/business-booking/:catId"),
  widget: routeName.value === "widget",
  scheme: routeName.value === "booking" && screenType.value === "mobile",
  default: !["auth-biz", "auth-eviso", "auth-client"].includes(routeName.value),
  editor: routeName.value === "booking-scheme",
}));

const currentHeader = computed(() => {
  if (headersMap.value.editBooking) return HeaderEditBooking;
  if (headersMap.value.reservations) return HeaderReservations;
  if (headersMap.value.widget) return HeaderWidget;
  if (headersMap.value.scheme) return HeaderScheme;
  if (headersMap.value.editor) return HeaderSchemeEditor;
  if (headersMap.value.default) return Header;
  return null;
});
</script>
